import { render, staticRenderFns } from "./SendNotificationByTarget.html?vue&type=template&id=33e360b4&external"
import script from "./SendNotificationByTarget.js?vue&type=script&lang=js&external"
export * from "./SendNotificationByTarget.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports